export default __webpack_public_path__ + "static/media/house.icon.ea03a613.svg";